import React from 'react';

export default function HeroBanner(props) {
  return (
    <div className="overview-product__hero-banner">
      <img src={props.banner} className="banner img-fluid w-100" />
    </div>
  );
}
